(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/shared-components/iam-iframe-message-handler.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/shared-components/iam-iframe-message-handler.js');

'use strict';

if (svs.accountservices.check_iam.isIamIFrameEnabled) {
  var _svs, _svs2;
  const {
    getReturnUrlForEidApp
  } = svs.playerLoginReact.sharedComponents.iamIframeEidAppHandler;
  const POST_MESSAGE_SOURCE = 'svs-iam-parent';
  const TRUSTED_ORIGIN = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.playerLoginReact) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.origins) === null || _svs === void 0 ? void 0 : _svs.trusted;
  const TRUSTED_REDIRECT_URLS = ((_svs2 = svs) === null || _svs2 === void 0 || (_svs2 = _svs2.playerLoginReact) === null || _svs2 === void 0 || (_svs2 = _svs2.data) === null || _svs2 === void 0 ? void 0 : _svs2.trustedRedirectUrls) || [];

  const POST_MESSAGE_TYPES = {
    HEIGHT: 'height',
    SHOW_DIALOG: 'show-dialog',
    SHOW_DIALOG_RESOLVED: 'show-dialog-resolved',
    SHOW_DIALOG_EXTENDED: 'show-dialog-extended',
    SHOW_DIALOG_EXTENDED_RESOLVED: 'show-dialog-extended-resolved',
    PARENT_REDIRECT: 'parent-redirect',
    GET_ONBOARDING_DATA: 'get-onboarding-data',
    FULLSCREEN: 'fullscreen',
    REMOVE_FULLSCREEN: 'remove-fullscreen',
    UPDATE_ONBOARDING_DATA: 'update-onboarding-data',
    SET_LOGIN_TYPE: 'set-login-type',
    UPDATE_PARENT_QUERYSTRING: 'update-parent-querystring',
    PARENT_QUERYSTRING_UPDATED: 'parent-querystring-updated',
    PARENT_ONBOARDING_DATA_UPDATED: 'parent-onboarding-data-updated',
    PARENT_TRACK_EVENT: 'parent-track-event',
    PARENT_TRACK_EVENT_RESOLVED: 'parent-track-event-resolved',
    GET_PARENT_SLO: 'get-parent-slo',
    GOT_PARENT_SLO: 'got-parent-slo',
    DELETE_PARENT_SLO: 'delete-parent-slo',
    PARENT_SLO_DELETED: 'parent-slo-deleted'
  };
  const {
    showDialog,
    showDialogExtended
  } = svs.playerLoginReact.sharedComponents.Dialogs;
  const isTrustedRedirectUrl = url =>
  TRUSTED_REDIRECT_URLS.some(trustedRedirectUrl => url.startsWith(trustedRedirectUrl));
  window.addEventListener('message', async event => {
    var _event$data;
    if (event.origin !== TRUSTED_ORIGIN && event.origin !== window.location.origin) {
      return; 
    }

    const iframe = document.getElementById('iamlogin-iframe');
    if ((event === null || event === void 0 || (_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.source) === 'svs-iam-iframe') {
      var _event$data2, _event$data5, _event$data9, _event$data14, _event$data21, _event$data22, _event$data23, _event$data24, _event$data25, _event$data28, _event$data30, _event$data31, _event$data33, _event$data34, _event$data35, _event$data36, _event$data37, _event$data38;
      if ((event === null || event === void 0 || (_event$data2 = event.data) === null || _event$data2 === void 0 ? void 0 : _event$data2.messageType) === POST_MESSAGE_TYPES.HEIGHT) {
        if (!iframe.classList.contains('iamlogin-iframe-fullscreen')) {
          var _event$data3, _event$data4;
          iframe.style.height = (_event$data3 = event.data) !== null && _event$data3 !== void 0 && _event$data3.value ? "".concat((_event$data4 = event.data) === null || _event$data4 === void 0 ? void 0 : _event$data4.value, "px") : 'auto';
        }
      } else if ((event === null || event === void 0 || (_event$data5 = event.data) === null || _event$data5 === void 0 ? void 0 : _event$data5.messageType) === POST_MESSAGE_TYPES.SHOW_DIALOG) {
        var _event$data6, _event$data7, _event$data8;
        await showDialog((_event$data6 = event.data) === null || _event$data6 === void 0 || (_event$data6 = _event$data6.value) === null || _event$data6 === void 0 ? void 0 : _event$data6.title, (_event$data7 = event.data) === null || _event$data7 === void 0 || (_event$data7 = _event$data7.value) === null || _event$data7 === void 0 ? void 0 : _event$data7.errorMessage);
        iframe.contentWindow.postMessage({
          source: POST_MESSAGE_SOURCE,
          messageType: POST_MESSAGE_TYPES.SHOW_DIALOG_RESOLVED
        }, event.origin);
        if ((_event$data8 = event.data) !== null && _event$data8 !== void 0 && (_event$data8 = _event$data8.value) !== null && _event$data8 !== void 0 && _event$data8.redirectUrl) {
          svs.utils.url.navigate(svs.utils.url.makeInternal(event.data.value.redirectUrl, svs.core.urlMapping.get('startPage')));
        }
      } else if ((event === null || event === void 0 || (_event$data9 = event.data) === null || _event$data9 === void 0 ? void 0 : _event$data9.messageType) === POST_MESSAGE_TYPES.SHOW_DIALOG_EXTENDED) {
        var _event$data0, _event$data1, _event$data10, _event$data11, _event$data12, _event$data13;
        const resolvedValue = await showDialogExtended((_event$data0 = event.data) === null || _event$data0 === void 0 || (_event$data0 = _event$data0.value) === null || _event$data0 === void 0 ? void 0 : _event$data0.title, (_event$data1 = event.data) === null || _event$data1 === void 0 || (_event$data1 = _event$data1.value) === null || _event$data1 === void 0 ? void 0 : _event$data1.message, (_event$data10 = event.data) === null || _event$data10 === void 0 || (_event$data10 = _event$data10.value) === null || _event$data10 === void 0 ? void 0 : _event$data10.icon, (_event$data11 = event.data) === null || _event$data11 === void 0 || (_event$data11 = _event$data11.value) === null || _event$data11 === void 0 ? void 0 : _event$data11.type, (_event$data12 = event.data) === null || _event$data12 === void 0 || (_event$data12 = _event$data12.value) === null || _event$data12 === void 0 ? void 0 : _event$data12.actions);
        iframe.contentWindow.postMessage({
          source: POST_MESSAGE_SOURCE,
          messageType: POST_MESSAGE_TYPES.SHOW_DIALOG_EXTENDED_RESOLVED,
          resolvedValue
        }, event.origin);
        if ((_event$data13 = event.data) !== null && _event$data13 !== void 0 && (_event$data13 = _event$data13.value) !== null && _event$data13 !== void 0 && _event$data13.redirectUrl) {
          svs.utils.url.navigate(svs.utils.url.makeInternal(event.data.value.redirectUrl, svs.core.urlMapping.get('startPage')));
        }
      } else if ((event === null || event === void 0 || (_event$data14 = event.data) === null || _event$data14 === void 0 ? void 0 : _event$data14.messageType) === POST_MESSAGE_TYPES.PARENT_REDIRECT) {
        var _event$data15, _event$data17, _event$data18;
        let navigateUrl;
        let target;

        if (typeof ((_event$data15 = event.data) === null || _event$data15 === void 0 ? void 0 : _event$data15.value) === 'string') {
          var _event$data16;
          target = undefined;
          navigateUrl = (_event$data16 = event.data) === null || _event$data16 === void 0 ? void 0 : _event$data16.value;
        } else if (typeof ((_event$data17 = event.data) === null || _event$data17 === void 0 ? void 0 : _event$data17.value) === 'object' && ((_event$data18 = event.data) === null || _event$data18 === void 0 ? void 0 : _event$data18.value) !== null) {
          var _event$data19, _event$data20;
          target = (_event$data19 = event.data) === null || _event$data19 === void 0 || (_event$data19 = _event$data19.value) === null || _event$data19 === void 0 ? void 0 : _event$data19.target;
          navigateUrl = (_event$data20 = event.data) === null || _event$data20 === void 0 || (_event$data20 = _event$data20.value) === null || _event$data20 === void 0 ? void 0 : _event$data20.url;
        }

        if (!isTrustedRedirectUrl(navigateUrl)) {
          navigateUrl = svs.utils.url.makeInternal(navigateUrl, svs.core.urlMapping.get('startPage'));
        }
        if (target && typeof target === 'string' && target.trim() !== '') {
          window.open(navigateUrl, target);
        } else {
          svs.utils.url.navigate(navigateUrl);
        }
      } else if ((event === null || event === void 0 || (_event$data21 = event.data) === null || _event$data21 === void 0 ? void 0 : _event$data21.messageType) === POST_MESSAGE_TYPES.GET_ONBOARDING_DATA) {
        var _svs3, _extraData$branding, _extraData$branding$t;
        const extraData = await ((_svs3 = svs) === null || _svs3 === void 0 || (_svs3 = _svs3.accountservices) === null || _svs3 === void 0 || (_svs3 = _svs3.onboardingHandler) === null || _svs3 === void 0 ? void 0 : _svs3.getExtraData());
        const theme = svs.accountservices.onboardingHandler.getTheme((extraData === null || extraData === void 0 || (_extraData$branding = extraData.branding) === null || _extraData$branding === void 0 || (_extraData$branding$t = _extraData$branding.toLowerCase) === null || _extraData$branding$t === void 0 ? void 0 : _extraData$branding$t.call(_extraData$branding)) || '');
        const state = svs.playerLoginReact.storeRef.getState();
        const {
          cancelUrl,
          returnUrl,
          isReturnNewCustomer
        } = state.playerloginreact;
        iframe.contentWindow.postMessage({
          source: POST_MESSAGE_SOURCE,
          messageType: POST_MESSAGE_TYPES.GET_ONBOARDING_DATA,
          value: {
            extraData,
            cancelUrl,
            returnUrl,
            isReturnNewCustomer,
            theme,
            product: (theme === null || theme === void 0 ? void 0 : theme.branding) || 'tur-100'
          }
        }, event.origin);
      } else if ((event === null || event === void 0 || (_event$data22 = event.data) === null || _event$data22 === void 0 ? void 0 : _event$data22.messageType) === POST_MESSAGE_TYPES.FULLSCREEN) {
        iframe.classList.add('iamlogin-iframe-fullscreen');
        iframe.style.height = '100%';
      } else if ((event === null || event === void 0 || (_event$data23 = event.data) === null || _event$data23 === void 0 ? void 0 : _event$data23.messageType) === POST_MESSAGE_TYPES.REMOVE_FULLSCREEN) {
        iframe.classList.remove('iamlogin-iframe-fullscreen');
        iframe.style.height = '';
      } else if ((event === null || event === void 0 || (_event$data24 = event.data) === null || _event$data24 === void 0 ? void 0 : _event$data24.messageType) === POST_MESSAGE_TYPES.UPDATE_ONBOARDING_DATA && (_event$data25 = event.data) !== null && _event$data25 !== void 0 && _event$data25.requestId) {
        var _event$data26, _event$data27;
        const updateOnboardingUrls = value => new Promise(resolve => {
          svs.core.deviceSession.set('onboardingUrls', 'customer_login', value, () => {
            resolve();
          });
        });
        const updatedOnboardingData = await svs.accountservices.onboardingHandler.updateExtraData({
          newExtraData: ((_event$data26 = event.data) === null || _event$data26 === void 0 || (_event$data26 = _event$data26.value) === null || _event$data26 === void 0 ? void 0 : _event$data26.onboardingData) || {}
        });
        await updateOnboardingUrls(((_event$data27 = event.data) === null || _event$data27 === void 0 || (_event$data27 = _event$data27.value) === null || _event$data27 === void 0 ? void 0 : _event$data27.onboardingUrls) || {});
        const response = {
          source: POST_MESSAGE_SOURCE,
          requestId: event.data.requestId,
          messageType: POST_MESSAGE_TYPES.PARENT_ONBOARDING_DATA_UPDATED,
          value: updatedOnboardingData
        };
        iframe.contentWindow.postMessage(response, event.origin);
      } else if ((event === null || event === void 0 || (_event$data28 = event.data) === null || _event$data28 === void 0 ? void 0 : _event$data28.messageType) === POST_MESSAGE_TYPES.SET_LOGIN_TYPE) {
        var _event$data29;
        const setIamLoginType = value => new Promise(resolve => {
          svs.core.deviceSession.set('loginType', 'iam', value, () => {
            resolve();
          });
        });
        await setIamLoginType(((_event$data29 = event.data) === null || _event$data29 === void 0 ? void 0 : _event$data29.value) || 'BANKID');
      } else if ((event === null || event === void 0 || (_event$data30 = event.data) === null || _event$data30 === void 0 ? void 0 : _event$data30.messageType) === POST_MESSAGE_TYPES.UPDATE_PARENT_QUERYSTRING && (_event$data31 = event.data) !== null && _event$data31 !== void 0 && _event$data31.requestId) {
        var _event$data32;
        const {
          serializedLoginObject,
          isBankId
        } = ((_event$data32 = event.data) === null || _event$data32 === void 0 ? void 0 : _event$data32.value) || {};
        const parentQuerystring = getReturnUrlForEidApp(serializedLoginObject, isBankId);
        const response = {
          source: POST_MESSAGE_SOURCE,
          requestId: event.data.requestId,
          messageType: POST_MESSAGE_TYPES.PARENT_QUERYSTRING_UPDATED,
          value: parentQuerystring
        };
        iframe.contentWindow.postMessage(response, event.origin);
      } else if ((event === null || event === void 0 || (_event$data33 = event.data) === null || _event$data33 === void 0 ? void 0 : _event$data33.messageType) === POST_MESSAGE_TYPES.GET_PARENT_SLO && (_event$data34 = event.data) !== null && _event$data34 !== void 0 && _event$data34.requestId) {
        var _svs4;
        const response = {
          source: POST_MESSAGE_SOURCE,
          requestId: event.data.requestId,
          messageType: POST_MESSAGE_TYPES.GOT_PARENT_SLO,
          value: (_svs4 = svs) === null || _svs4 === void 0 || (_svs4 = _svs4.playerLoginReact) === null || _svs4 === void 0 || (_svs4 = _svs4.data) === null || _svs4 === void 0 ? void 0 : _svs4.parentSlo
        };
        iframe.contentWindow.postMessage(response, event.origin);
      } else if ((event === null || event === void 0 || (_event$data35 = event.data) === null || _event$data35 === void 0 ? void 0 : _event$data35.messageType) === POST_MESSAGE_TYPES.DELETE_PARENT_SLO && (_event$data36 = event.data) !== null && _event$data36 !== void 0 && _event$data36.requestId) {
        var _svs5, _svs6;
        const deletedParentSlo = (_svs5 = svs) === null || _svs5 === void 0 || (_svs5 = _svs5.playerLoginReact) === null || _svs5 === void 0 || (_svs5 = _svs5.data) === null || _svs5 === void 0 ? void 0 : _svs5.parentSlo;
        if ((_svs6 = svs) !== null && _svs6 !== void 0 && (_svs6 = _svs6.playerLoginReact) !== null && _svs6 !== void 0 && (_svs6 = _svs6.data) !== null && _svs6 !== void 0 && _svs6.parentSlo) {
          delete svs.playerLoginReact.data.parentSlo;
          svs.playerLoginReact.data.parentSlo = undefined;
        }
        const response = {
          source: POST_MESSAGE_SOURCE,
          requestId: event.data.requestId,
          messageType: POST_MESSAGE_TYPES.PARENT_SLO_DELETED,
          value: deletedParentSlo
        };
        iframe.contentWindow.postMessage(response, event.origin);
      } else if ((event === null || event === void 0 || (_event$data37 = event.data) === null || _event$data37 === void 0 ? void 0 : _event$data37.messageType) === POST_MESSAGE_TYPES.PARENT_TRACK_EVENT && (_event$data38 = event.data) !== null && _event$data38 !== void 0 && _event$data38.requestId) {
        var _event$data39;
        const asyncTrackEvent = value => new Promise(resolve => {
          svs.components.analytics.trackEvent(value, () => {
            resolve();
          });
        });
        await asyncTrackEvent(((_event$data39 = event.data) === null || _event$data39 === void 0 ? void 0 : _event$data39.value) || {});
        event.source.postMessage({
          source: POST_MESSAGE_SOURCE,
          requestId: event.data.requestId,
          messageType: POST_MESSAGE_TYPES.PARENT_TRACK_EVENT_RESOLVED
        }, event.origin);
      }
    }
  });
}

 })(window);